import { css, Paper, styled } from '@mui/material';
import { XIcon } from '@phosphor-icons/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';

import { IconButtonLink } from '@/components/router/IconButtonLink';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';
import { transientOptions } from '@/utils/transient-options';

export const Root = styled(
  Paper,
  transientOptions,
)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.paper};
    display: flex;
    flex-direction: column;
    height: calc(100% - ${theme.spacing(7)});
    width: 100%;
    z-index: 10;
    transition: height 0.3s ease-in-out;
    padding: 0 ${theme.spacing(2)};
    position: fixed;
    border-radius: 0;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      position: inherit;
      height: 100%;
      width: ${theme.spacing(58)};
      flex-shrink: 0;
      z-index: 1;
    }
  `,
);

export const StyledIconButtonLink = styled(IconButtonLink)(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.spacing(4)};
    right: ${theme.spacing(1)};
    z-index: 1;
    border-radius: 0;
  `,
) as typeof IconButtonLink;

export const Route = createFileRoute('/_public/_map/_sidebar')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Root>
      <StyledIconButtonLink search from={Route.fullPath} size="medium" to="/">
        <XIcon />
      </StyledIconButtonLink>

      <Suspense>
        <Outlet />
      </Suspense>
    </Root>
  );
}
